@if (product) {
  <a
    class="card card--product"
    [ngClass]="{ 'card--product--large': isLarge }"
    [target]="isExternalLink ? '_system' : null"
    [airLink]="productUrl"
    [userEventSource]="userEventSource"
    [userEventLabel]="product.title"
    [userEventObject]="userEventObject"
  >
    <div class="card__image">
      <figure>
        <air-focal-image [image]="product.primaryImage" [isCropped]="true"></air-focal-image>
      </figure>
    </div>
    <div class="card__stickers">
      @if (product) {
        <air-miles-sticker [product]="product" [size]="isLarge ? 'md' : undefined"></air-miles-sticker>
      }
    </div>
    @if (isExternalLink) {
      <div class="card__icon"><i class="icon icon--sm icon-ui-logout"></i></div>
    }
    <div class="card__text">
      @if (product.title) {
        <h3 class="card__title">{{ product.title }}</h3>
      }
      @if (product.shortDescription && !isDescriptionHidden) {
        <div class="card__description">
          <p>{{ product.shortDescription }}</p>
        </div>
      }
    </div>
  </a>
}
